import { api } from '@marketplace-web/core-api/core-api-client-data'

import { GetTransactionArgs, GetTransactionResp } from '../types/transaction'

const moneyObjectHeader = {
  'X-Money-Object': 'true',
}

export const getTransaction = ({ id }: GetTransactionArgs) =>
  api.get<GetTransactionResp>(`/transactions/${id}`, { headers: moneyObjectHeader })
